import { getEnv } from '@/utils/env';
import { getIdToken } from '@/services/msal';
import { STORAGE_KEYS } from '@/constants';

/**
 * Base URL for API requests (same as RTK Query baseUrl).
 */
export function getApiBaseUrl(): string {
  return getEnv('VITE_API_BASE_URL', 'http://localhost:3001/api');
}

/**
 * Auth (and optional SSE) headers for API requests.
 * Use eventStream: true for SSE endpoints (Accept: text/event-stream).
 */
export async function getApiHeaders(options?: {
  eventStream?: boolean;
}): Promise<Record<string, string>> {
  const currentToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
  const { token: idToken, graphToken: accessToken } =
    await getIdToken(currentToken);
  const headers: Record<string, string> = {};
  if (idToken) {
    headers['Authorization'] = `Bearer ${idToken}`;
  }
  if (accessToken) {
    headers['x-graph-token'] = `Bearer ${accessToken}`;
  }
  if (options?.eventStream) {
    headers['Accept'] = 'text/event-stream';
  }
  return headers;
}
